{
	"title": "Verklaringen",
	"table": {
		"material": "Materiaal",
		"dateOfIssue": "Datum van uitgifte",
		"quantity": "Hoeveelheid",
		"carbonSavings": "CO\u2082-reducties",
		"status": {
			"title": "Status",
			"TransactionProcessing": "Transactie wordt verwerkt",
			"CreatingDeclaration": "Verklaring wordt aangemaakt",
			"GenerationFailed": "Genereren mislukt",
			"ReadyToDownload": "Klaar om te downloaden"
		}
	},
	"declarationLanguageSelect": {
		"title": "Verklaringstaal",
		"description": "Selecteer een taal voor de verklaring.",
		"label": "Verklaringstaal",
		"buttonBack": "Terug",
		"buttonSave": "Opslaan"
	},
	"downloadAllLanguageSelect": {
		"title": "Verklaringstalen",
		"descriptionGlobal": "Selecteer een taal voor alle verklaringen.",
		"descriptionIndividual": "Of stel de taal in voor elke verklaring afzonderlijk.",
		"label": "Verklaringstalen",
		"tableHeaderDeclaration": "Verklaring (materiaal/datum van uitgifte)",
		"tableHeaderLanguage": "Verklaringstaal",
		"buttonBack": "Terug",
		"buttonDownload": "Download verklaringen"
	},
	"declarationActions": {
		"changeLanguage": "Verklaringstaal wijzigen",
		"preview": "Voorbeeld",
		"download": "Downloaden",
		"transaction": "Transactie",
		"showMoreTransactions": "Meer transacties weergeven",
		"languageLabel": "Verklaringstaal",
		"downloadAll": "Alle verklaringen downloaden"
	}
}
